import React, { useState, useEffect } from 'react';
import './NavbarDashboard.css';
import { Link as Anchor, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faUsers, faImage, faChevronDown, faChevronUp, faCode, faClipboardList, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faGauge, faStore, faList, faRectangleList, faBuilding, faTag, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { faProductHunt } from '@fortawesome/free-brands-svg-icons';
import { fetchUsuario, getUsuario } from '../../user';
import Logout from '../Logout/Logout';
import baseURL from '../../url';
import { puedeVerMenu } from '../../../Helpers/rolesPermisos';

export default function Navbar() {
    const location = useLocation();
    const [tienda, setTienda] = useState([]);
    const [expanded, setExpanded] = useState(false); // Estado para controlar la expansión
    const [detallesVisibles, setDetallesVisibles] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const handleToggleNavbar = () => {
        setExpanded(!expanded); // Alternar el estado de expansión
    };

    const toggleDetalles = () => {
        setDetallesVisibles(!detallesVisibles)
    };

    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario(); // Llama a la función para obtener datos del usuario
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    // Funciones auxiliares para determinar si mostrar cada sección
    const puedeVerCitasTalleres = () => {
        if (!puedeVerMenu(usuarioLegued?.rol, 'citas-talleres')) return false;
        if (usuarioLegued?.rol !== 'terapeuta') return true;
        return Number(usuarioLegued?.permite_grupal) === 1;
    };

    const tieneMenusOperacion = () => {
        return puedeVerCitasTalleres() ||
               puedeVerMenu(usuarioLegued?.rol, 'turnos') ||
               puedeVerMenu(usuarioLegued?.rol, 'citas') ||
               puedeVerMenu(usuarioLegued?.rol, 'disponibilidad');
    };

    const tieneMenusCatalogos = () => {
        return puedeVerMenu(usuarioLegued?.rol, 'categorias') ||
               puedeVerMenu(usuarioLegued?.rol, 'servicios') ||
               puedeVerMenu(usuarioLegued?.rol, 'talleres');
    };

    const tieneMenusGestion = () => {
        return puedeVerMenu(usuarioLegued?.rol, 'banners') ||
               puedeVerMenu(usuarioLegued?.rol, 'usuarios');
    };

    const tieneMenusComunicacion = () => {
        return puedeVerMenu(usuarioLegued?.rol, 'contacto');
    };

    const tieneMenusReportes = () => {
        return puedeVerMenu(usuarioLegued?.rol, 'reportes');
    };

    return (
        <div className={`navbarDashboard ${expanded ? 'expanded' : ''}`}>

            <Anchor className='logo' id='logo'  >
                <div className='logo' >
                    {tienda?.imagen1 ? (
                        <img src={tienda?.imagen1} alt="logo" />
                    ) : (
                        <></>
                    )}
                    <div className='deColumnNav'>
                        {usuarioLegued?.nombre ? (
                            <ss>{usuarioLegued?.nombre}</ss>
                        ) : (
                            <ss>Sistema</ss>
                        )}
                        {usuarioLegued?.email ? (
                            <ss>{usuarioLegued?.email}</ss>
                        ) : (
                            <ss>sistema@gmail.com</ss>
                        )}
                    </div>
                </div>
                <button onClick={handleToggleNavbar} className="nav_toggle2">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

            </Anchor>

            {loading ? (
                <></>
            ) : usuarioLegued?.idUsuario ? (
                <div className='links'>
                    <div className="nav-section-label">Inicio</div>
                    {puedeVerMenu(usuarioLegued.rol, 'dashboard') && (
                        <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                            <FontAwesomeIcon icon={faGauge} /> Dashboard
                        </Anchor>
                    )}

                    {tieneMenusOperacion() && (
                        <>
                            <div className="nav-section-label">Operación</div>
                            {puedeVerCitasTalleres() && (
                                <Anchor to={`/dashboard/citas-talleres`} className={location.pathname === '/dashboard/citas-talleres' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faRectangleList} /> Citas Talleres
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'turnos') && (
                                <Anchor to={`/dashboard/turnos`} className={location.pathname === '/dashboard/turnos' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faRectangleList} /> Mis Citas
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'citas') && (
                                <Anchor to={`/dashboard/citas`} className={location.pathname === '/dashboard/citas' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faRectangleList} /> Citas (Coordinador)
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'disponibilidad') && (
                                <Anchor to={`/dashboard/disponibilidad`} className={location.pathname === '/dashboard/disponibilidad' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faRectangleList} /> Disponiblilidad
                                </Anchor>
                            )}
                        </>
                    )}

                    {tieneMenusCatalogos() && (
                        <>
                            <div className="nav-section-label">Catálogos</div>
                            {puedeVerMenu(usuarioLegued.rol, 'categorias') && (
                                <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faList} /> Centros
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'servicios') && (
                                <Anchor to={`/dashboard/servicios`} className={location.pathname === '/dashboard/servicios' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faProductHunt} /> Programas
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'talleres') && (
                                <Anchor to={`/dashboard/talleres`} className={location.pathname === '/dashboard/talleres' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faChalkboardTeacher} /> Talleres
                                </Anchor>
                            )}
                        </>
                    )}

                    {tieneMenusGestion() && (
                        <>
                            <div className="nav-section-label">Gestión</div>
                            {puedeVerMenu(usuarioLegued.rol, 'banners') && (
                                <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faImage} /> Banners
                                </Anchor>
                            )}
                            {puedeVerMenu(usuarioLegued.rol, 'usuarios') && (
                                <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faUser} /> Usuarios
                                </Anchor>
                            )}
                        </>
                    )}

                    {tieneMenusComunicacion() && (
                        <>
                            <div className="nav-section-label">Comunicación</div>
                            {puedeVerMenu(usuarioLegued.rol, 'contacto') && (
                                <Anchor to={`/dashboard/contacto`} className={location.pathname === '/dashboard/contacto' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faUsers} /> Contacto
                                </Anchor>
                            )}
                        </>
                    )}

                    {tieneMenusReportes() && (
                        <>
                            <div className="nav-section-label">Reportes</div>
                            {puedeVerMenu(usuarioLegued.rol, 'reportes') && (
                                <Anchor to={`/dashboard/reportes`} className={location.pathname === '/dashboard/reportes' ? 'activeLink' : ''}>
                                    <FontAwesomeIcon icon={faClipboardList} /> Reportes
                                </Anchor>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <div className='links'>
                    <div className="nav-section-label">Inicio</div>
                    <Anchor to={`/dashboard`} className={location.pathname === '/dashboard' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faGauge} /> Dashboard
                    </Anchor>

                    <div className="nav-section-label">Operación</div>
                    <Anchor to={`/dashboard/citas-talleres`} className={location.pathname === '/dashboard/citas-talleres' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faRectangleList} /> Citas Talleres
                    </Anchor>
                    <Anchor to={`/dashboard/turnos`} className={location.pathname === '/dashboard/turnos' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faRectangleList} /> Citas
                    </Anchor>
                    <Anchor to={`/dashboard/citas`} className={location.pathname === '/dashboard/citas' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faRectangleList} /> Citas (Coordinador)
                    </Anchor>
                    <Anchor to={`/dashboard/disponibilidad`} className={location.pathname === '/dashboard/disponibilidad' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faRectangleList} /> Disponiblilidad
                    </Anchor>

                    <div className="nav-section-label">Catálogos</div>
                    <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faList} /> Centros
                    </Anchor>
                    <Anchor to={`/dashboard/servicios`} className={location.pathname === '/dashboard/servicios' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faProductHunt} /> Programas
                    </Anchor>
                    <Anchor to={`/dashboard/talleres`} className={location.pathname === '/dashboard/talleres' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faChalkboardTeacher} /> Talleres
                    </Anchor>

                    <div className="nav-section-label">Gestión</div>
                    <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faImage} /> Banners
                    </Anchor>
                    <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faUser} /> Usuarios
                    </Anchor>

                    <div className="nav-section-label">Comunicación</div>
                    <Anchor to={`/dashboard/contacto`} className={location.pathname === '/dashboard/contacto' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faUsers} /> Contacto
                    </Anchor>

                    <div className="nav-section-label">Reportes</div>
                    <Anchor to={`/dashboard/reportes`} className={location.pathname === '/dashboard/reportes' ? 'activeLink' : ''}>
                        <FontAwesomeIcon icon={faClipboardList} /> Reportes
                    </Anchor>
                </div>
            )}




            <Logout />
        </div>
    );
}
